<template>
  <div class="page-home">
    <div class="page-home-header">
      <home-header :reverse="true"></home-header>
    </div>
    <div class="page-home-main">
      <home-main :menu-code="$route.params.currentMenu"></home-main>
    </div>
    <div class="page-home-footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import HomeHeader from './HomeHeader'
import HomeMain from './HomeMain'
import Footer from '../common/Footer'

export default {
  name: 'PageHome',
  components: {
    HomeHeader,
    HomeMain,
    Footer
  }
}
</script>

<style lang="scss">
.page-home {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  &>.page-home-header {
    flex: none;
  }
  &>.page-home-main {
    flex: auto;
    background-color: #f6f4f4;
  }
  &>.page-home-footer {
    height: 60px;
    flex: none;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/index.vue